/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Row as RRow } from 'reactstrap';

// eslint-disable-next-line react/prefer-stateless-function
class Row extends React.Component {
  render() {
    return <RRow {...this.props}>{this.props.children}</RRow>;
  }
}

Row.propTypes = {
  children: PropTypes.any,
};

export default Row;
